import { useGetList } from 'react-admin';

import type { FinancialIndexShortName } from '@Common/constants/financial_indexes';
import type { GetOpsActionsIndexesItem } from '@Common/types/bo/ops_actions/indexes';

import { isBoExternal } from '@sh4res/bo-common/utils/env';

export function useFinancialIndex(shortName: FinancialIndexShortName) {
  const resource = isBoExternal() ? 'indexes' : 'ops_actions/indexes';
  const { data, isFetched } = useGetList<GetOpsActionsIndexesItem>(resource, {
    filter: {
      short_name: shortName,
    },
    pagination: { page: 1, perPage: 25 },
  });

  return {
    resource,
    index: data?.find((item) => item.short_name === shortName),
    isFetched,
  };
}
